

<div cdkDrag [cdkDragDisabled]="!draggable" class="tile-container {{tile.color}} {{size}} {{tile.cssclass}}">

  <div class="tile-content-container">
    <ng-container *ngIf="tileTemplate">
      <ng-container *ngTemplateOutlet="tileTemplate.template; context:tileTemplate.context"></ng-container>
    </ng-container>
    <ng-content></ng-content>
  </div>
  <div class="tile-separator"></div>
  <div class="tile-footer draggable" cdkDragHandle>
    <span>{{tile.title}}</span>
    <span *ngIf="tile.ispinned" (click)="onIsPinned()" class="fa-solid fa-thumbtack"></span>
    <span *ngIf="!tile.ispinned" (click)="onIsPinned()" class="fa-regular fa-thumbtack fa-rotate-90"></span>
    <span *ngIf="tile.applicationType=='workspace'">
      <i class="fa {{tile.peopleIcon}}" style="margin-left:5px;"></i>
    </span>
    <span *ngIf="tile.applicationType=='assessment'">
      <i class="fa {{tile.peopleIcon}}" style="margin-left:5px;"></i>
    </span>



  </div>
</div>
